import { IApplicationState } from '../../../types/types';
import { getAuthUser } from '../../../store/model/authUser/selectors/getAuthUser';
import { root } from '../../../store/constants';

export const getFirstVisitSessionRecordingNeeded = (
    state: IApplicationState
) => {
    if (!root.App.controller.mainView.getFirstVisitSessionRecording()) {
        return false;
    }
    const { firstVisit } = getAuthUser(state);
    const COOKIE_NAME = 'sessionReplay';
    const isFirstVisit = firstVisit && root.App.Util.getCookie(COOKIE_NAME) === undefined;
    if (isFirstVisit) {
        root.App.Util.setCookie(COOKIE_NAME, true);
    }
    return isFirstVisit;
};
